export const environment = {
  baseUrl: 'https://retention.uat-usc1.aodocs.app',
  finraApiUrl: 'https://retention.uat-usc1.aodocs.app',
  apiUrl: '/_ah/api/',
  aodocsUrl: 'https://aodocs-staging.altirnao.com/',
  clientId: '336465149492-5cfkmf391gtfvqudfqsvp4fulf1c562o',
  gcsAPI: 'https://storage.googleapis.com/upload/storage/v1/b/{BUCKET}/o',
  ossApi: 'https://aodocs-object-storage-staging.appspot.com/api/storage',
  version: '4.0.0',
  production: false,
  microsoftAuthEnabled: true,
  googleAuthEnabled: true,
  firebase: {
    apiKey: 'AIzaSyBWo5_zgbMgKf5nbYrn749NgvNGkBri23k',
    authDomain: 'ao-docs-staging.firebaseapp.com',
    databaseURL: 'https://ao-docs-staging.firebaseio.com',
    projectId: 'ao-docs-staging',
    storageBucket: 'ao-docs-staging.appspot.com',
    messagingSenderId: '563231141203',
    appId: '1:563231141203:web:69fd2c6b041e95f93845a6',
    measurementId: 'G-0RJZXTDXBR',
  }
};
